import api from '@/utils/api';

// ----------------------------------------------------------------------
//
// Web Push subscription registry — talks to the NestJS NotificationsModule.
//
//   GET    /notifications/vapid-public-key   → { publicKey, enabled }
//   POST   /notifications/subscriptions      → store a browser subscription
//   DELETE /notifications/subscriptions      → drop it by endpoint
//
// The backend is the single source of truth for the VAPID public key, so
// the client fetches it instead of relying on a build-time env var (which
// would have to be kept in sync with the server keypair).
//
// ----------------------------------------------------------------------

export interface VapidKeyResponse {
  publicKey: string | null;
  enabled: boolean;
}

/** Server's VAPID public key. Falls back to disabled on any error. */
export const getVapidPublicKey = async (): Promise<VapidKeyResponse> => {
  try {
    return (await api.get('/notifications/vapid-public-key')) as VapidKeyResponse;
  } catch {
    return { publicKey: null, enabled: false };
  }
};

/** Register (or refresh) the current device's push subscription. */
export const subscribePush = async (subscription: PushSubscription): Promise<void> => {
  const json = subscription.toJSON();
  if (!json.endpoint || !json.keys?.p256dh || !json.keys?.auth) {
    throw new Error('Suscripción de push inválida');
  }
  await api.post('/notifications/subscriptions', {
    params: {
      endpoint: json.endpoint,
      keys: { p256dh: json.keys.p256dh, auth: json.keys.auth },
    },
  });
};

/** Remove this device's subscription on the server. */
export const unsubscribePush = async (endpoint: string): Promise<void> => {
  await api.delete('/notifications/subscriptions', {
    params: { endpoint },
  });
};
